import React from 'react';
import { arrayOf, object, string } from 'prop-types';
import { uniq, compact, sortBy, get } from 'lodash';
import { I18n } from '@fiverr-private/fiverr_context';

import './style.scss';

const MetadataAttribute = ({ name, options, metadata }) => {
    const validOptions = uniq(compact(options));
    const sortedOptions = sortBy(validOptions, (option) => get(metadata, `metadataOptions.${option}`, 0));
    const filteredOptions = compact(sortedOptions.map((option) => {
        const translationKey = get(metadata, `metadataOptions.${option}.translationKey`);

        return translationKey ? { translationKey, option } : null;
    }));

    if (!(name && metadata && filteredOptions.length > 0)) {
        return null;
    }

    return (
        <li className="metadata-attribute">
            <p>
                <I18n k={metadata.translationKey}/>
            </p>
            <ul>
                {
                    filteredOptions.map((optionObj) => (
                        <li key={optionObj.option}>
                            <I18n k={optionObj.translationKey}/>
                        </li>
                    ))
                }
            </ul>
        </li>
    );
};

MetadataAttribute.propTypes = {
    name: string,
    options: arrayOf(string),
    metadata: object
};

export default MetadataAttribute;
